import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { AuthService } from 'src/app/Services/services/auth.service';
import { UserAuthManager } from 'src/app/Services/user-sessions/user-auth-manager';
import {
  HttpErrorUtil,
  HttpUnauthorizedException,
} from 'src/app/utils/http-util/http-error.util';
import { environment } from 'src/environments/environment';
import { IRelocateFlashcardPayload } from '../interfaces/flashcard.interface';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RelocateFlashcardService {
  private BASE_URL = environment.apiBaseUrl;

  constructor(
    private readonly toaster: ToastrService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly httpClient: HttpClient
  ) {}

  public relocateFlashcard(
    relocateFlashCardPayload: IRelocateFlashcardPayload
  ) {
    return this.httpClient
      .post<string>(
        `${this.BASE_URL}/api/RelocateFlashCard`,
        relocateFlashCardPayload
      )
      .pipe(catchError((err: HttpErrorResponse) => this.handlerError(err)));
  }

  private handlerError(err: HttpErrorResponse) {
    const error = HttpErrorUtil.sanitizeError(err);

    if (error instanceof HttpUnauthorizedException) {
      UserAuthManager.userSessionLogout.next();
      this.authService.logout();
      this.router.navigate(['/login']);
      this.toaster.warning(error.message, 'Logout Successfully');
    } else {
      this.toaster.error(error.message, 'Error');
    }

    return throwError(error);
  }
}
